import { createFileRoute } from "@tanstack/react-router";
import { PublicChangelog } from "@/components/changelog/public-changelog";

// A project's public changelog. Anyone can open it: it shows published
// entries of a project whose public page is on, and nothing else.
export const Route = createFileRoute("/p/$slug/changelog")({
  component: PublicChangelogRoute,
});

function PublicChangelogRoute() {
  const { slug } = Route.useParams();
  return <PublicChangelog key={slug} slug={slug} />;
}
